const ITEMS = [
  "Ontruiming & hergebruik",
  "Meer ruimte. Minder zorgen.",
  "Garages — Zolders — Schuren — Bergingen",
  "Laarbeek & omgeving",
  "Bewaren, hergebruiken of afvoeren",
];

const Seq = ({ hidden }) => (
  <div className="marquee__seq" aria-hidden={hidden || undefined}>
    {ITEMS.map((item) => (
      <span className="marquee__item" key={item}>
        {item}
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="marquee" data-testid="marquee">
      <div className="marquee__track">
        <Seq />
        <Seq hidden />
      </div>
    </div>
  );
}
